import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {DiscrepanciesData} from '../../../domain/discrepancies-data.model';
import {CurrencyPipe, DecimalPipe, PercentPipe} from '@angular/common';

@Component({
  selector: 'cm-discrepancies-table',
  template: `
    <mat-table #table [dataSource]="dataSource"
               matSort matSortActive="revenueDiscrepancyAmount"
               matSortDirection="desc"
               class="">
      <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
        <mat-header-cell mat-sort-header *matHeaderCellDef>{{ column.header }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ column.cell(row) }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="visibleColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: visibleColumns"></mat-row>
    </mat-table>
  `,
  styles: [`
    .mat-column-demandPartner {
      flex: 0 0 110px;
    }

    .mat-column-revenueDiscrepancy {
      flex: 0 0 85px;
      text-align: right;
    }

    .mat-column-revenueDiscrepancyAmount {
      flex: 0 0 70px;
      text-align: right;
    }
  `]
})
export class DiscrepanciesTableComponent implements AfterViewInit, OnInit {

  @Input() paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  @Input('data')
  set data(data: DiscrepanciesData[]) {
    this.dataSource.data = data;
  }

  @Input('visibleColumns')
  visibleColumns = [];

  dataSource = new MatTableDataSource<DiscrepanciesData>();


  ngOnInit(): void {
    if (!this.visibleColumns || !this.visibleColumns.length) {
      this.visibleColumns = this.columns.map(c => c.key);
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  columns = [
    {key: 'adUnitName', header: 'Ad unit name', cell: (row: DiscrepanciesData) => `${row.adUnitName}`},
    {key: 'demandPartner', header: 'Demand partner', cell: (row: DiscrepanciesData) => `${row.demandPartner}`},
    {
      key: 'dfpRevenue',
      header: 'DFP revenue',
      cell: (row: DiscrepanciesData) => `${row.dfpRevenue ? this.numberPipe.transform(row.dfpRevenue, '1.2-2') : '-'}`
    },
    {
      key: 'dpRevenue',
      header: 'Partner revenue',
      cell: (row: DiscrepanciesData) => `${row.dpRevenue ? this.numberPipe.transform(row.dpRevenue, '1.2-2') : '-'}`
    },
    {
      key: 'revenueDiscrepancy',
      header: '% Rev DIFF',
      cell: (row: DiscrepanciesData) => `${row.revenueDiscrepancy ? this.percentPipe.transform(((row.revenueDiscrepancy || 0) / 100), '1.2-2') : '-'}`
    },
    {
      key: 'revenueDiscrepancyAmount',
      header: 'Rev Diff',
      cell: (row: DiscrepanciesData) => `${row.revenueDiscrepancyAmount ? this.currencyPipe.transform(row.revenueDiscrepancyAmount, 'USD', 'symbol', '1.2-2') : '-'}`
    },
    {
      key: 'dfpImpressions',
      header: 'DFP filled imps',
      cell: (row: DiscrepanciesData) => `${row.dfpImpressions ? this.numberPipe.transform(row.dfpImpressions) : '-'}`
    },
    {
      key: 'dpImpressions',
      header: 'Partner filled imps',
      cell: (row: DiscrepanciesData) => `${row.dpImpressions ? this.numberPipe.transform(row.dpImpressions) : '-'}`
    },
    {
      key: 'impressionsDiscrepancy',
      header: '% Imp. DIFF',
      cell: (row: DiscrepanciesData) => `${row.impressionsDiscrepancy ? this.numberPipe.transform(row.impressionsDiscrepancy) : '-'}`
    },
    {
      key: 'dfpAdRequests',
      header: 'DFP requests',
      cell: (row: DiscrepanciesData) => `${row.dfpAdRequests ? this.numberPipe.transform(row.dfpAdRequests) : '-'}`
    },
    {
      key: 'dpAdRequests',
      header: 'Partner requests',
      cell: (row: DiscrepanciesData) => `${row.dpAdRequests ? this.numberPipe.transform(row.dpAdRequests) : '-'}`
    },
    {
      key: 'adRequestsDiscrepancy',
      header: '% Ad.Req. DIFF',
      cell: (row: DiscrepanciesData) => `${row.adRequestsDiscrepancy ? this.numberPipe.transform(row.adRequestsDiscrepancy) : '-'} `
    }];


  constructor(private numberPipe: DecimalPipe,
              private percentPipe: PercentPipe,
              private currencyPipe: CurrencyPipe) {
  }

  getColumns() {
    return this.columns;
  }

  setVisibleColumns(cols: string[]) {
    this.visibleColumns = cols;
  }
}

